import Cookies from 'js-cookie';
import {
  FM_REFERRAL_COOKIE_NAME,
  FOLLOWER_HUB_COOKIE_NAME,
  FOLLOWER_ID_COOKIE_NAME,
  REFCODE_COOKIE_HUB,
  REFCODE_COOKIE_NAME,
  REFERRAL_COOKIE_HUB,
  REFERRAL_COOKIE_NAME,
  UTM_COOKIE_NAME,
} from 'constants/index';
import { getGclid } from './getGclid';
import { getHubByRoutingHub } from 'helpers/hubs';

const getAdditionalData = (params, prefix) => {
  const data = {};
  const followerId = Cookies.get(FOLLOWER_ID_COOKIE_NAME) || params.followerId;
  const followerHub = Cookies.get(FOLLOWER_HUB_COOKIE_NAME) || params.followerHub;
  if (followerId) {
    data.followerId = followerId;
  }

  const refcode = Cookies.get(REFCODE_COOKIE_NAME) || params[REFCODE_COOKIE_NAME];
  const refhub = Cookies.get(REFCODE_COOKIE_HUB) || params[REFCODE_COOKIE_NAME];

  if (refcode) {
    data.refcode = refcode;
  }
  if (refhub) {
    data.hub = refhub;
  }

  const referral = params.cxd || Cookies.get(REFERRAL_COOKIE_NAME);
  if (referral) {
    data.cxd = referral;
    data.subID = params.subID;
    const cxdHub = Cookies.get(REFERRAL_COOKIE_HUB);
    if (cxdHub) {
      data.hub = cxdHub;
    }
  }
  if (followerHub) {
    data.hub = followerHub;
  }

  const hub = getHubByRoutingHub(prefix);
  if (hub && !data.hub) {
    data.hub = hub.KEY;
  }

  const utm = Cookies.get(UTM_COOKIE_NAME);
  if (utm) {
    data.utm = JSON.parse(utm);
  }
  const inviteFriendCode = Cookies.get(FM_REFERRAL_COOKIE_NAME) || params.referral;
  if (inviteFriendCode) {
    data.inviteFriendCode = inviteFriendCode;
  }

  const gclid = getGclid();
  if (gclid) {
    data.gclid = gclid;
  }

  return data;
};

export default getAdditionalData;
